import { MappedResourceTimingKeys } from './types/MappedResourceTimingKeys';
import { getResourceName } from './getResourceName';
import { getTime } from './scriptParseEndTimes';

let optics: MappedResourceTimingKeys[] = [];
export function getResourceTiming(): MappedResourceTimingKeys[] {
    return optics;
}

export function addStartResourceTimings(windowObj: Window) {
    let entries: any[] = null;
    if (windowObj.performance && windowObj.performance.getEntriesByType) {
        entries = windowObj.performance.getEntriesByType('resource');
    }

    if (entries) {
        for (let i = 0; i < entries.length; ++i) {
            let entry: PerformanceResourceTiming = entries[i];
            let ro: MappedResourceTimingKeys = {};
            ro.nam = getResourceName(entry.name);
            ro.st = entry.startTime | 0;
            ro.dur = entry.duration | 0;
            entry.redirectStart && (ro.reds = entry.redirectStart | 0);
            entry.redirectEnd && (ro.rede = entry.redirectEnd | 0);
            entry.fetchStart && (ro.fs = entry.fetchStart | 0);
            entry.domainLookupStart && (ro.dls = entry.domainLookupStart | 0);
            entry.domainLookupEnd && (ro.dle = entry.domainLookupEnd | 0);
            entry.connectStart && (ro.cs = entry.connectStart | 0);
            entry.connectEnd && (ro.ce = entry.connectEnd | 0);
            (<any>entry).secureConnectionStart && (ro.scs = (<any>entry).secureConnectionStart | 0);
            entry.requestStart && (ro.reqs = entry.requestStart | 0);
            entry.responseStart && (ro.ress = entry.responseStart | 0);
            entry.responseEnd && (ro.rese = entry.responseEnd | 0);
            (<any>entry).workerStart && (ro.ws = (<any>entry).workerStart | 0);
            getTime(ro.nam) && (ro.pe = getTime(ro.nam) | 0);
            optics.push(ro);
        }
    }

    return optics;
}
